import React, { useState } from "react";

// Images
import img1 from "../Accests/images/instumrnt/IMG-20250702-WA0002.jpg";
import img2 from "../Accests/images/instumrnt/IMG-20250702-WA0003.jpg";
import img3 from "../Accests/images/instumrnt/IMG-20250702-WA0004.jpg";
import img4 from "../Accests/images/instumrnt/IMG-20250702-WA0005.jpg";

// Videos
import vid1 from "../Accests/images/instumrnt/VID-20250702-WA0001.mp4";
import vid2 from "../Accests/images/instumrnt/VID-20250702-WA0004.mp4";
import vid3 from "../Accests/images/instumrnt/VID-20250702-WA0005.mp4";

const InstrumentalMusic = () => {
    const [previewSrc, setPreviewSrc] = useState(null);
    const [isVideo, setIsVideo] = useState(false);

    const openPreview = (src, type) => {
        setPreviewSrc(src);
        setIsVideo(type === "video");
    };

    const closePreview = () => {
        setPreviewSrc(null);
        setIsVideo(false);
    };

    return (
        <>
            <div className="pt-24 px-6 bg-gray-100 min-h-screen">
                <h1 className="text-4xl font-bold text-center mb-8 text-blue-600">Instrumental Music</h1>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {[img1, img2, img3, img4].map((img, i) => (
                        <img
                            key={i}
                            src={img}
                            alt={`Instrument ${i + 1}`}
                            onClick={() => openPreview(img, "image")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                        />
                    ))}

                    {[vid1, vid2, vid3].map((vid, i) => (
                        <video
                            key={i}
                            src={vid}
                            onClick={() => openPreview(vid, "video")}
                            className="w-full h-64 object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
                            muted
                            autoPlay
                            loop
                        />
                    ))}
                </div>

                <p className="text-gray-700 mt-6 text-lg leading-relaxed text-center">
                    Immerse yourself in the calming rhythms and melodies of our live instrumental music sessions,
                    perfect for creating an unforgettable ambiance under the stars.
                </p>
            </div>

            {/* Preview Modal */}
            {previewSrc && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
                    <div className="absolute inset-0" onClick={closePreview}></div>

                    <div className="relative z-10 max-w-4xl w-full p-4">
                        <button
                            onClick={closePreview}
                            className="absolute top-4 right-4 z-20 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold hover:bg-red-600 hover:text-white transition"
                        >
                            &times;
                        </button>
                        {isVideo ? (
                            <video src={previewSrc} className="w-full rounded-lg" controls autoPlay />
                        ) : (
                            <img src={previewSrc} alt="Preview" className="w-full rounded-lg" />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default InstrumentalMusic;
